import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=7120e5f6&scoped=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=js"
export * from "./HeaderLogo.vue?vue&type=script&lang=js"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=7120e5f6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120e5f6",
  null
  
)

export default component.exports